import { localStorer } from '../../lib/localStorer-sidecar'

export const version = '0.1.1-kft'

export const isLocal = window.location.href.includes('localhost:8080')

// export const experimentalMultiplayer = true
export const useRemoteMultiplayer = !isLocal || true
export const disableDirector = false
export const multiplayerAutoJoin = true
export const singleplayerAutoJoin = false

export const isDevMode = true && isLocal

export type VoyageTestMode =
  | 'normal'
  | 'editor'
  | 'game'
  | 'body-align'
  | 'test'
const settingKey = '_voyage_testmode'
export let testMode: VoyageTestMode = 'normal'
export const loadTestMode = (): VoyageTestMode => {
  let loadedTestMode =
    (localStorer.load(settingKey, 1) as VoyageTestMode) || 'normal'
  return loadedTestMode
}
export const setTestMode = (tm: VoyageTestMode) => {
  localStorer.save(settingKey, 1, tm)
  window.location.reload()
}

// export let skipRequireTech = true
// export let doTestGraphics = false

// export let testParticles = false

// export let testSpeedMult = 1
// export let testDealParts: boolean = false
// export let autoFullTest: boolean = false
// export let autoBuild: boolean = false || autoFullTest
// export let autoLoadCargo: boolean = (false || autoFullTest) && autoBuild
// export let autoLoadAstronauts: boolean = (false || autoFullTest) && autoBuild
// export let autoLaunch: boolean = (false || autoFullTest) && autoBuild
// export let autoChoosePath: boolean = (false || autoFullTest) && autoBuild
// export let autoFight: boolean = (false || autoFullTest) && autoBuild
// export let autoEndMission: boolean = (false || autoFullTest) && autoBuild
// export let autoSelectMission: boolean = (false || autoFullTest) && autoBuild

// export let shipClass: goatShipClassData.GoatShipClassType = 'c4'
